// user follows the default outbound call recording logic of company
export const OUTBOUND_CALL_RECORDING_MODE_DEFAULT = 1
// all outbound calls will be recorded
export const OUTBOUND_CALL_RECORDING_MODE_ALWAYS = 2
// all outbound calls won't be recorded
export const OUTBOUND_CALL_RECORDING_MODE_NEVER = 3
